import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResponse } from '../dto/api-response.response';
import { ServiceCategoryRequest } from '../dto/service-category.request';
import { ServiceCategoryResponse } from '../dto/service-category.response';

@Injectable({ providedIn: 'root' })
export class ServiceCategoryService {
    private readonly baseUrl = `${environment.apiUrl}/service-categories`;

    constructor(private http: HttpClient) {}

    getAll(status?: number): Observable<ApiResponse<ServiceCategoryResponse[]>> {
        let params = new HttpParams();
        if (status !== undefined) params = params.set('status', status);
        return this.http.get<ApiResponse<ServiceCategoryResponse[]>>(this.baseUrl, { params });
    }

    create(req: ServiceCategoryRequest): Observable<ApiResponse<ServiceCategoryResponse>> {
        return this.http.post<ApiResponse<ServiceCategoryResponse>>(this.baseUrl, req);
    }

    update(id: number, req: ServiceCategoryRequest): Observable<ApiResponse<ServiceCategoryResponse>> {
        return this.http.put<ApiResponse<ServiceCategoryResponse>>(`${this.baseUrl}/${id}`, req);
    }

    updateStatus(id: number, status: number): Observable<ApiResponse<void>> {
        return this.http.patch<ApiResponse<void>>(`${this.baseUrl}/${id}/status`, { status });
    }
}
